module.exports = __webpack_public_path__ + "static/img/aaa9b541ac392b726a7b1cebe1de32cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/foot_icon1.png
// module id = jePs
// module chunks = 1